export function NotFound() {
	return (
		<section>
			<h1>404: Recurso No Encontrado</h1>
			<p>No pudimos encontrar lo que buscas :(</p>
		</section>
	);
}
